var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectedMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "ikon for tilkoblet medlemskap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28139 15.896C13.6419 15.1883 16.6032 11.0797 15.8955 6.7191C15.1878 2.35854 11.0792 -0.602691 6.71861 0.105C2.35805 0.81269 -0.603179 4.92132 0.104512 9.28187C0.812202 13.6424 4.92083 16.6037 9.28139 15.896ZM11.1992 8.72037C12.1591 8.72037 12.9589 7.9205 12.9589 6.88067C12.9589 5.84084 12.1591 5.04098 11.1992 5.04098C10.2394 5.04098 9.35953 5.84084 9.35953 6.88067C9.35953 7.9205 10.2394 8.72037 11.1992 8.72037ZM7.91977 5.84084C7.91977 7.04064 6.95993 8.00048 5.76013 8.00048C4.56033 8.00048 3.60049 7.04064 3.60049 5.84084C3.60049 4.64104 4.56033 3.6812 5.76013 3.6812C6.95993 3.6812 7.91977 4.64104 7.91977 5.84084ZM7.19989 9.68021C6.55999 9.52023 6.00009 9.44025 5.60015 9.44025C4.80029 9.44025 3.60048 9.68021 2.56066 10.0801C3.12056 11.5199 4.16039 12.6397 5.60015 13.2796V12.1598C5.60015 11.5199 5.84011 10.4801 7.19989 9.68021ZM11.1992 10.1601C11.6791 10.1601 12.399 10.2401 13.1189 10.4801C12.2391 12.3998 10.2394 13.7595 7.91977 13.7595C7.79979 13.7595 7.67981 13.7395 7.55983 13.7195C7.43985 13.6995 7.31987 13.6795 7.19989 13.6795V12.1598C7.19989 10.8 9.91944 10.1601 11.1992 10.1601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedMembership);
export default __webpack_public_path__ + "static/media/connected_membership.7a68ac98.svg";
export { ForwardRef as ReactComponent };